import { Common } from './Common';
import { UserPd } from './UserPd';

export class User extends Common {
    name: string;
    last_name: string;
    gender: string;
    dob: Date;
    url: string;
    age: number;
    user_pd: UserPd = new UserPd();
}
